<script>
  import { dev } from '$app/env'
</script>

<svelte:head>
  {#if !dev}
    <!-- Google tag (gtag.js) -->
    <script
      async
      src="https://www.googletagmanager.com/gtag/js?id=AW-16578385335"
    ></script>
    <script>
      window.dataLayer = window.dataLayer || []
      function gtag() {
        dataLayer.push(arguments)
      }
      gtag('js', new Date())
      gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
      })
      gtag('config', 'AW-16578385335')
    </script>
  {:else}
    <script>
      function gtag() {
        console.log('gtag()', arguments)
      }
    </script>
  {/if}
</svelte:head>
